<template>
  <button
    v-on="$listeners"
    class="px-4 py-2 rounded-lg font-normal shadow transition-shadow hover:shadow-md duration-200 focus:outline-none"
    :class="[
      {
        'bg-gray-900 text-white': variant === 'primary'
      },
      {
        'bg-white text-gray-600 hover:text-gray-700': variant === 'secondary'
      }
    ]"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "BButton",
  props: {
    variant: {
      type: String,
      default: "primary",
      validator: val => ["primary", "secondary"].indexOf(val) !== -1
    }
  }
};
</script>
